export interface InstructionStepProps {
  imageSrc: string;
  imageBgClass: string;
  gradientClass: string;
  text: string;
}

export function InstructionStep({
  imageSrc,
  imageBgClass,
  gradientClass,
  text,
}: InstructionStepProps) {
  return (
    <div className="flex flex-col items-center w-40 md:w-auto">
      <div
        className={`w-40 h-32 md:w-40 md:h-28 rounded-2xl shadow-lg ${imageBgClass} bg-center bg-cover`}
        style={{ backgroundImage: `url(${imageSrc})` }}
      />
      <div className={`px-4 py-3 w-40 bg-gradient-to-b ${gradientClass}`}>
        <h3 className="text-sm md:text-base leading-tight text-center">
          {text}
        </h3>
      </div>
    </div>
  );
}
